import axios from "axios";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

const url = "/v1/msp/wizard";

export const createOnboarding = async (data: any) => {
  try {
    const response = await axiosClient.post(url, data);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const updateOnboarding = async (data: any) => {
  try {
    const response = await axiosClient.patch(url, data);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getOnboarding = async () => {
  try {
    const response = await axiosClient.get(url);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};




